import { InputPadrao, InputDatePicker, InputTelefone } from '../../../../components/Inputs'
import { InputMunicipio, InputOperadoraSaude } from '../../../../components/InputsAutoComplete'
import React, { useState, useEffect } from 'react'
import Yup, { validaCPF, validaData } from '../../../../util/Validacoes'
import { HeaderCadastro } from '../../../../components/Headers'
import { mostrarToast } from '../../../../components/Toasts'
import { Formik, Form } from 'formik'
import { BotaoPadrao } from '../../../../components/Botoes'
import { ajustarDadosTelefone, buscarCep, mensagens } from '../../../../util/Utilitarios'
import { useParams } from 'react-router-dom'
import { Link } from 'react-router-dom'
import { salvar, get } from '../../../../util/AcessoApi'
import '../../../../assets/css/icones/iconsmind/style.css';
import Atalho from '../../../../util/Atalho'

const CadastroTipoDocumentoSocio = (props) => {
    let { id } = useParams()

    const [salvarENovo, setSalvarENovo] = useState(false)
    const [salvando, setSalvando] = useState(false)
    const [valoresIniciais, setValoresIniciais] = useState({})

    const [validacao] = useState(Yup.object({
        descricao: Yup.string().required().nullable().max(200).trim(),

    }))

    const manter = []


    const Submit = (values, propsFormik) => {
        setSalvando(true)

        salvar(
            { ...values },
            '/administracao/sociotipodocumento',
            obj => {
                mostrarToast('sucesso', mensagens.sucesso)
                if (salvarENovo) {
                    propsFormik.resetForm({})
                    manter.forEach(x => propsFormik.setFieldValue(x, values[x]))
                    setSalvando(false)
                    setSalvarENovo(false)
                }
                else {
                    props.setItemSelecionado({ value: obj.id, label: obj.descricao })
                    props.setShow && props.setShow(false)
                }


            },
            () => setSalvando(false))
    }


    useEffect(_ => {
        if (props.modal && props.idBene)
            Promise.resolve(get(`/administracao/sociotipodocumento/${props.idBene}`)).then(obj => {
                setValoresIniciais(obj)
            })
    }, [props.idBene && props.idBene])

    return (
        <Formik
            initialValues={valoresIniciais}
            validationSchema={validacao}
            enableReinitialize={true}
            onSubmit={(values, propsFormik) => Submit(values, propsFormik)}>
            {propsFormik => {
                return (<Form>
                    <div className={props.modal && props.modal || 'card mb-20'}>
                        <div className={props.modal || 'card-body'}>
                            <div className='row'>
                                <InputPadrao label='Id' name='id' type='hidden' placeholder='Id' />
                                <InputPadrao label='Descrição' name='descricao' type='text' placeholder='Descrição' obrigatorio={true}
                                    tamanho={!props.modal && 'col-sm-12 col-lg-6 col-xl-6'} classeTooltip={props.modal && 'tooltip-input-modal'} autoFocus salvarENovo={salvarENovo} />

                                <Atalho formik={propsFormik} salvando={salvando} setSalvareNovo={setSalvarENovo} salvarENovo={true} />

                            </div>
                        </div>
                    </div>
                    {!props.modal && <div className='separator mt-40 mb-5'></div>}
                    <div className='direita container-botoes mb-3 group-salvar-novo'>
                        <BotaoPadrao texto='Salvar' disabled={salvando} click={_ => setSalvarENovo(false)} idTooltip={'salvar'} />
                        {(props.modal || !id) && <BotaoPadrao texto='Salvar e Novo' disabled={salvando} click={_ => setSalvarENovo(true)} idTooltip={'salvarENovo'} />}
                    </div>
                </Form>)
            }}
        </Formik>
    )
}

// const Cadastro = (props) => {
//     const links = [
//         () => <Link to={'/dashboard'}>Dashboard</Link>,
//         () => <span>faturamento</span>,
//         () => <Link className='link-active' to={'/faturamento/acomodacao/consulta'}>Acomodação</Link>,
//     ]
//     return (<>
//         {!props.modal && <HeaderCadastro titulo={"Cadastro Beneficiário"} link={links} />}
//         <CadastroPaciente {...props} />
//     </>
//     )
// }
// export { CadastroPaciente }
export default CadastroTipoDocumentoSocio